<template>
  <modal
    class="addNewRetainershipModal"
    name="addWaybillModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/Group 440.png" width="50px" />
          </span>
          {{ $t("text.waybillModal.add") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="name_input_div">
                    <input
                      type="date"
                      :placeholder="$t('text.waybillModal.wbDate')"
                      class="form-control w-100"
                      v-model="wayBillDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="phone_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.waybillModal.refNumber')"
                      class="form-control w-100"
                      v-model="referenceNumber"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="email_input_div">
                    <input
                      type="number"
                      :placeholder="$t('text.waybillModal.volume')"
                      class="form-control w-100"
                      v-model="volume"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="email_input_div">
                    <input
                      type="number"
                      :placeholder="$t('text.waybillModal.orderNo')"
                      class="form-control w-100"
                      v-model="orderNumber"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mt-4">
                <b-form-checkbox name="checkbox-1" @change="toggleCompanyTruck">
                  {{ $t("text.waybillModal.useComTruck") }}
                </b-form-checkbox>
              </div>
              <div class="col-md-6" v-if="companyTruck">
                <div class="mt-3 form_input_section">
                  <div class="mt-3 input__block">
                    <select v-model="selectedTruck">
                      <option value="selectCompanyTruck" selected disabled>
                        {{ $t("text.waybillModal.selComTruck") }}
                      </option>
                      <option
                        :value="truck.truckId"
                        v-for="(truck, index) in companyTrucksList"
                        :key="index"
                      >
                        <span>
                          {{ truck.firstName }}
                          {{ truck.lastName }} - {{ truck.plateNumber }}
                        </span>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6" v-else>
                <div class="mt-3 form_input_section">
                  <div class="mt-3 input__block" ref="state_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.waybillModal.unregTruckDes')"
                      class="form-control w-100"
                      v-model="unregisteredTruck"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mt-3 form_input_section">
                <div class="mt-3 input__block">
                  <select v-model="selectedProduct">
                    <option value="selectCompanyProd" selected disabled>
                      {{ $t("text.waybillModal.selectCompanyPro") }}
                    </option>
                    <option
                      :value="product.productId"
                      v-for="(product, index) in companyProductsList"
                      :key="index"
                    >
                      <span>
                        {{ product.productName }}
                      </span>
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6 mt-3 form_input_section">
                <div class="mt-3 input__block" ref="state_input_div">
                  <input
                    type="text"
                    :placeholder="$t('text.waybillModal.comment')"
                    class="form-control w-100"
                    v-model="comment"
                  />
                </div>
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="addWaybill($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.waybillModal.add") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "addWaybillModal",
  props: ["companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      wayBillDate: null,
      referenceNumber: null,
      volume: null,
      orderNumber: null,
      truckId: null,
      unregisteredTruck: null,
      comment: null,
      companyTruck: false,
      companyTrucksList: [],
      companyProductsList: [],
      selectedTruck: "selectCompanyTruck",
      selectedProduct: "selectCompanyProd",
      // messages: '',
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closed() {
      this.wayBillDate = null;
      this.referenceNumber = null;
      this.volume = null;
      this.orderNumber = null;
      this.truckId = null;
      this.unregisteredTruck = null;
      this.comment = null;
      this.companyTrucksList = null;
      this.selectedTruck = "selectCompanyTruck";
      this.selectedProduct = "selectCompanyProd";
      this.companyTruck = false;
      this.$modal.hide("addWaybillModal");
    },
    opened() {
      this.getCompanyProducts();
    },
    toggleCompanyTruck() {
      // console.log("company truck used");
      this.companyTruck = !this.companyTruck;
      this.getCompanyTrucks();
      this.unregisteredTruck = "";
      this.selectedTruck = "selectCompanyTruck";
    },
    getCompanyProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Products/${this.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.companyProductsList = response.data;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
    getCompanyTrucks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDriversWithTruck/${this.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.companyTrucksList = response.data;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
    addWaybill($event) {
      $event.preventDefault();
      if (!this.wayBillDate) {
        this.$toast.open({
          message: this.$t("text.waybillModal.dateErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.referenceNumber) {
        this.$toast.open({
          message: this.$t("text.waybillModal.refnoErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.volume) {
        this.$toast.open({
          message: this.$t("text.waybillModal.volErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.orderNumber) {
        this.$toast.open({
          message: this.$t("text.waybillModal.orderNoErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      const waybillVolume = parseInt(this.volume);

      let data = {
        companyId: this.companyId,
        wayBillDate: this.wayBillDate,
        referenceNumber: this.referenceNumber,
        volume: waybillVolume,
        orderNumber: this.orderNumber,
        truckId:
          this.selectedTruck == "selectCompanyTruck"
            ? null
            : this.selectedTruck,
        productId: this.selectedProduct,
        unregisteredTruck: this.unregisteredTruck,
        comment: this.comment,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Waybill/Add`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.closed();
          this.$toast.open({
            message: this.$t("text.waybillModal.successfullyAddedWb"),
            type: "success",
            duration: 3000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.wayBillDate = null;
          this.referenceNumber = null;
          this.volume = null;
          this.orderNumber = null;
          this.truckId = null;
          this.unregisteredTruck = null;
          this.comment = null;
          this.showLoader = false;
          this.$eventHub.$emit("getWaybills");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
        });
    },
  },
};
</script>
